import { flatten } from "@/common/helpers/array";
import { times } from "@/common/helpers/function";
import { getCmsAuthorizationHeaderObject, getCmsUrl, getDeepTranslationsFilter, serialize } from "@/services/cms";
import { httpClient } from "@/services/http";
import { LocaleCode } from "@/services/i18n";

import { getFooterResponseSchema } from "./get-footer.schema";
import type { GetFooterRequestProps } from "./get-footer.types";

export const GET_FOOTER_ENDPOINT = "/items/footer_new";

export const getFooterRequest = async ({ locale }: GetFooterRequestProps) => {
  const response = await httpClient
    .get(getCmsUrl(GET_FOOTER_ENDPOINT), {
      headers: getCmsAuthorizationHeaderObject(),
      params: {
        deep: {
          ...getDeepTranslationsFilter(LocaleCode.fromLocale(locale)),
        },
        fields: [
          "translations.company_name",
          "translations.company_street",
          "translations.company_city",
          "translations.nip",
          "translations.krs",
          "translations.regon",
          "translations.additional_info",
          ...flatten(times(4).map((i) => [`translations.column${i + 1}`, `translations.column_${i + 1}_label`])),
        ],
      },
      next: {
        tags: ["footer_new"],
        revalidate: false,
      },
      queryOptions: { arrayFormat: "comma" },
    })
    .then(serialize);

  return getFooterResponseSchema.parse(response);
};
